import React from "react";

const searchBox = ({searchfield, searchchange}) =>{
    return(<div className="pa2">

        <input className="pa3 ba b--green bg-lightest-blue"  type="search" placeholder="Search the robot" onChange={searchchange}/>

    </div>
    )
}


export default searchBox;